<ng-container *ngIf="application?.Fee">
  <ng-container *ngIf="shouldDisplayIsRecommendedCode">
    <boi-form-radio-button
      [isFieldDisabled]="application.IsApplicationReadOnly || application.IsFactFindReadOnly"
      [optionList]="referenceDataOptionLists.AnswerType"
      [labelName]="referenceDataLabels.IsRecommendedCode"
      [propertyNames]="['Fee.IsRecommendedCode']"
      [(value)]="application.Fee.IsRecommendedCode"
      [contextualHelpName]="referenceDataContextualHelps.IsRecommendedCode"
    ></boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="!application.IsAip && isValuationReportTypeCodeVisible">
    <boi-form-option-list
      [optionList]="referenceDataOptionLists.ValuationReportType"
      [labelName]="referenceDataLabels.ValuationReportTypeId"
      [propertyNames]="['Fee.ValuationReportTypeCode']"
      [(value)]="application.Fee.ValuationReportTypeCode"
      [contextualHelpName]="'FeesValuationReportType'"
      [isFieldDisabled]="isValuationReportTypeDisabled"
      (valueChange)="onValuationReportTypeChange()"
    >
    </boi-form-option-list>

    <ng-container
      *ngIf="
        application.Fee.ValuationReportTypeCode === referenceDataOptionLists.ValuationReportTypeBuildingSurvey &&
        isBuildingSurveyNoteVisible &&
        !isBuildingSurveyNoteAccepted
      "
    >
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [message]="referenceDataLabels.BuildingSurveyNoteId"
        [includeOkButton]="true"
        (buttonClickEvent)="isBuildingSurveyNoteAccepted = true"
        [buttonLabel]="referenceDataLabels.PleaseClickOkText | localizeLabel"
        [buttonDisabled]="application.IsApplicationReadOnly || application.IsFactFindReadOnly"
      >
      </boi-form-information-box>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!application.IsAip">
    <ng-container *ngIf="isReportCompletedBeforeMortgageVisible">
      <boi-form-radio-button
        [isFieldDisabled]="application.IsApplicationReadOnly"
        [optionList]="referenceDataOptionLists.AnswerType"
        [labelName]="referenceDataLabels.IsValuationCompletedBeforeId"
        [propertyNames]="['Fee.IsValuationCompletedBeforeCode']"
        [value]="application.Fee.IsValuationCompletedBeforeCode"
        (valueChange)="onIsValuationCompletedBeforeCodeChange($event)"
      ></boi-form-radio-button>

      <ng-container *ngIf="isReportCompletedBeforeMortgage()">
        <boi-form-radio-button
          [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
          [optionList]="referenceDataOptionLists.ValuationReportPayerType"
          [labelName]="referenceDataLabels.ValuationReportPayerTypeId"
          [propertyNames]="['Fee.ValuationReportPayerTypeCode']"
          [(value)]="application.Fee.ValuationReportPayerTypeCode"
        ></boi-form-radio-button>

        <ng-container *ngIf="isPayerTypeApplicant()">
          <boi-form-text-input
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [labelName]="referenceDataLabels.ValuationCompanyNameId"
            [(value)]="application.Fee.ValuationCompanyName"
            [propertyNames]="['Fee.ValuationCompanyName']"
          ></boi-form-text-input>

          <boi-form-numeric-input
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [isCurrency]="true"
            [fieldMaxLength]="5"
            [labelName]="referenceDataLabels.ValuationCompletedValueId"
            [(value)]="application.Fee.ValuationCompletedValue"
            [propertyNames]="['Fee.ValuationCompletedValue']"
          >
          </boi-form-numeric-input>
        </ng-container>

        <ng-container *ngIf="isPayerTypeVendor()">
          <boi-form-text-input
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [labelName]="referenceDataLabels.SurveyCompletedById"
            [(value)]="application.Fee.WhoCompletedSurvey"
            [propertyNames]="['Fee.WhoCompletedSurvey']"
          ></boi-form-text-input>
        </ng-container>

        <ng-container *ngIf="application.IsFullApp">
          <boi-form-radio-button
            [isFieldDisabled]="application.IsApplicationReadOnly"
            [optionList]="referenceDataOptionLists.AnswerType"
            [labelName]="referenceDataLabels.IsValuationReportWithin12Weeks"
            [propertyNames]="['Fee.IsValuationReportWithin12Weeks']"
            [(value)]="application.Fee.IsValuationReportWithin12Weeks"
          ></boi-form-radio-button>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="application.IsKfi && application.Fee?.ValuationReportTypeCode">
      <ng-container
        *ngIf="
          isFeeUpToDate && application.Fee.ValuationFee !== null && application.Fee.ValuationFee >= 0;
          else notFeesUpToDate
        "
      >
        <boi-form-numeric-input
          [isCurrency]="true"
          [labelName]="referenceDataLabels.ValuationFeeAmountId"
          [isFieldDisabled]="true"
          [(value)]="application.Fee.ValuationFee"
          [propertyNames]="['Fee.ValuationCompletedValue']"
        ></boi-form-numeric-input>
      </ng-container>

      <ng-template #notFeesUpToDate>
        <boi-form-text-input
          [labelName]="referenceDataLabels.ValuationFeeAmountId"
          [isFieldDisabled]="true"
          [value]="'Calculating...'"
          [propertyNames]="['Fee.ValuationCompletedValue']"
        ></boi-form-text-input>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="application.isBrokerApplication">
      <boi-mortgage-clubs
        class="application-form-input"
        [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
        [application]="application"
      ></boi-mortgage-clubs>
      <ng-container
        *ngIf="
          application.Fee.SubmitViaMortgageClubCode &&
          application.Fee.SubmitViaMortgageClubCode !== referenceDataOptionLists.AnswerTypeNo
        "
      >
        <boi-form-text-input
          [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
          [labelName]="referenceDataLabels.MembershipNumber"
          [(value)]="application.Fee.MortgageClubNumber"
          [propertyNames]="['Fee.MortgageClubNumber']"
          [fieldMaxLength]="30"
        ></boi-form-text-input>
      </ng-container>

      <boi-form-information-box [decoration]="'exclamation-mark'" [message]="referenceDataLabels.FeeRefundable">
      </boi-form-information-box>

      <boi-form-numeric-input
        [ngClass]="{ 'field-with-checkbox': application.Fee.IntermediaryFeeApplication }"
        [isFieldDisabled]="application.IsApplicationReadOnly"
        [fieldMaxLength]="5"
        [isCurrency]="true"
        [labelName]="referenceDataLabels.FeePayableAtApplicationId"
        [(value)]="application.Fee.IntermediaryFeeApplication"
        [propertyNames]="['Fee.IntermediaryFeeApplication']"
      >
        <ng-container *ngIf="application.Fee.IntermediaryFeeApplication">
          <boi-form-checkbox
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [contextualHelpName]="referenceDataLabels.FeePayableAtApplicationId"
            [controlId]="'IntermediaryFeeApplicationRefundableCode'"
            [checkboxLabel]="referenceDataLabels.RefundableId | localizeLabel"
            [(value)]="application.Fee.IntermediaryFeeApplicationRefundableCode"
            [trueValue]="referenceDataOptionLists.AnswerTypeYes"
            [falseValue]="undefined"
          ></boi-form-checkbox>
        </ng-container>
      </boi-form-numeric-input>

      <boi-form-numeric-input
        [ngClass]="{ 'field-with-checkbox': application.Fee.IntermediaryFeeOffer }"
        [isFieldDisabled]="application.IsApplicationReadOnly"
        [fieldMaxLength]="5"
        [isCurrency]="true"
        [labelName]="referenceDataLabels.FeePayableAtOfferId"
        [(value)]="application.Fee.IntermediaryFeeOffer"
        [propertyNames]="['Fee.IntermediaryFeeOffer']"
      >
        <ng-container *ngIf="application.Fee.IntermediaryFeeOffer">
          <boi-form-checkbox
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [contextualHelpName]="referenceDataLabels.FeePayableAtOfferId"
            [controlId]="'IntermediaryFeeOfferRefundableCode'"
            [checkboxLabel]="referenceDataLabels.RefundableId | localizeLabel"
            [(value)]="application.Fee.IntermediaryFeeOfferRefundableCode"
            [trueValue]="referenceDataOptionLists.AnswerTypeYes"
            [falseValue]="undefined"
          ></boi-form-checkbox>
        </ng-container>
      </boi-form-numeric-input>

      <!-- 233 -->
      <boi-form-numeric-input
        [ngClass]="{ 'field-with-checkbox': application.Fee.IntermediaryFeeCompletion }"
        [isFieldDisabled]="application.IsApplicationReadOnly"
        [fieldMaxLength]="5"
        [isCurrency]="true"
        [labelName]="referenceDataLabels.FeePayableAtCompletionId"
        [(value)]="application.Fee.IntermediaryFeeCompletion"
        [propertyNames]="['Fee.IntermediaryFeeCompletion']"
      >
        <ng-container *ngIf="application.Fee.IntermediaryFeeCompletion">
          <boi-form-checkbox
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [contextualHelpName]="referenceDataLabels.FeePayableAtCompletionId"
            [controlId]="'IntermediaryFeeCompletionRefundableCode'"
            [checkboxLabel]="referenceDataLabels.RefundableId | localizeLabel"
            [(value)]="application.Fee.IntermediaryFeeCompletionRefundableCode"
            [trueValue]="referenceDataOptionLists.AnswerTypeYes"
            [falseValue]="undefined"
          ></boi-form-checkbox>
        </ng-container>
      </boi-form-numeric-input>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isFeeUpToDate">
    <ng-container *ngIf="application.Fee.ArrangementFee">
      <boi-form-numeric-input
        [ngClass]="{ 'field-with-checkbox': application.Fee.ArrangementFee }"
        [isCurrency]="true"
        [isFieldDisabled]="true"
        [labelName]="referenceDataLabels.ArrangementFeeId"
        [contextualHelpName]="'FeeArrangementIncluded'"
        [(value)]="application.Fee.ArrangementFee"
      >
        <boi-form-checkbox
          [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
          [contextualHelpName]="'FeeArrangementIncluded'"
          [controlId]="'ArrangementFeeIncludedCode'"
          [checkboxLabel]="referenceDataLabels.AddToLoanAmountId | localizeLabel"
          [(value)]="application.Fee.ArrangementFeeIncludedCode"
          [trueValue]="referenceDataOptionLists.AnswerTypeYes"
          [falseValue]="referenceDataOptionLists.AnswerTypeNo"
        >
        </boi-form-checkbox>
      </boi-form-numeric-input>
    </ng-container>

    <ng-container *ngIf="application.Fee.HigherLendingCharge">
      <boi-form-numeric-input
        [ngClass]="{ 'field-with-checkbox': application.Fee.HigherLendingCharge }"
        [forceRequired]="true"
        [isCurrency]="true"
        [isFieldDisabled]="true"
        [labelName]="referenceDataLabels.HigherLendingChargeId"
        [(value)]="application.Fee.HigherLendingCharge"
        [contextualHelpName]="'FeeHigherLendingIncluded'"
      >
        <ng-container *ngIf="application.Fee.HigherLendingCharge">
          <boi-form-checkbox
            [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
            [contextualHelpName]="'FeeHigherLendingIncluded'"
            [controlId]="'HigherLendingChargeIncludedCode'"
            [checkboxLabel]="referenceDataLabels.AddToLoanAmountId | localizeLabel"
            [(value)]="application.Fee.HigherLendingChargeIncludedCode"
            [trueValue]="referenceDataOptionLists.AnswerTypeYes"
            [falseValue]="referenceDataOptionLists.AnswerTypeNo"
          >
          </boi-form-checkbox>
        </ng-container>
      </boi-form-numeric-input>
    </ng-container>

    <ng-container *ngIf="application.IsKfi">
      <ng-container *ngIf="application.Fee.BookingFee">
        <boi-form-numeric-input
          [isCurrency]="true"
          [isFieldDisabled]="true"
          [labelName]="referenceDataLabels.BookingFeeId"
          [(value)]="application.Fee.BookingFee"
        >
        </boi-form-numeric-input>
      </ng-container>

      <!--Hide if it's broker interface from config-->
      <ng-container *ngIf="application.isBrokerApplication && isDprEnabled">
        <boi-form-numeric-input
          [isFieldDisabled]="application.IsFactFindReadOnly || application.IsApplicationReadOnly"
          [isCurrency]="true"
          [fieldMaxLength]="7"
          [labelName]="referenceDataLabels.TotalProcurationFeePayable"
          [(value)]="application.Fee.ProcurationFee"
          [propertyNames]="['Fee.ProcurationFee']"
          [contextualHelpName]="'TotalProcurationFeePayable'"
        >
        </boi-form-numeric-input>
      </ng-container>

      <ng-container *ngIf="application.Fee.PayableTo && isDprEnabled">
        <boi-form-text-input
          [labelName]="referenceDataLabels.ProcurationFeePayableTo"
          [isFieldDisabled]="true"
          [(value)]="application.Fee.PayableTo"
        ></boi-form-text-input>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!isFeeUpToDate">
    <boi-form-information-box [decoration]="'exclamation-mark'" [message]="referenceDataLabels.FeesOutOfDateWarning">
    </boi-form-information-box>
  </ng-container>
</ng-container>
